import { render, staticRenderFns } from "./ReportBulletPointTable.vue?vue&type=template&id=38c29fb4&"
import script from "./ReportBulletPointTable.vue?vue&type=script&lang=ts&"
export * from "./ReportBulletPointTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports